var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App_Main_Content",style:(_vm.$route.path.indexOf('admin')>-1?{overflow:'auto !important'}:'')},[_c(_vm.layout,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }